<template>
    <div :class="{timelinecard: true, timelinecard2x: size > 1, timelinecardwithpic: picture != null}">
    	<img v-bind:src="picture"
    		 v-bind:class="picture == null ? 'no-pic' : ''">
    	<div class="midline"></div>
    	<div class="t-info">
    		<div class="t-header">{{header}}</div>
    		<div class="t-descr">{{description}}</div>
    	</div>
    </div>
</template>
<script>
export default {
    props: ["ID", "header", "description", "picture", "size","offset"],
}
</script>
<style scoped>
.timelinecard {
	position: relative;
    width: 200px;
    height: 600px;
    display: flex;
    flex-direction: column;
    margin-left: 100px;
}

.timelinecard .no-pic{
	opacity: 0;
}

.timelinecard > img{
	width: 100%;
	height: 250px;
	border: none;
	object-fit: cover; /*cover = clips; contain: shows full image; fill: stretches the image ignoring proportions*/
}

.timelinecard .midline{
	width: 300px;
	height: 50px;
	top: 250px;
	position: absolute;
	background: #bbbb00;
}

.timelinecard .t-info{
	margin-top: 50px;
	background: #ddd;
	width: 200px;
	height: 300px;
}
.timelinecard .t-header{
	font-weight: bold;
	font-size: 1.5em;
}

.timelinecardwithpic {
}

.timelinecard2x {
    width: 400px !important;
}

.timelinecard2x .midline{
	width: 500px;
}

.timelinecard2x .t-info{
	width: 400px;
}

.timelinecard2x >img{
	width: 400px;
	height: 250px;
	border: none;
}


</style>